type ModalContentProps = {
  children: any;
};

export const ModalContent: React.FC<ModalContentProps> = ({ children }) => {
  return <div className="marketplace--modal-content">{children}</div>;
};
